import { useHandleResize } from "@hook";
import { getSqlServerGuidHash, sendMetric, getWhatId, getAbTestMetrika } from "@utils";

import { inject, observer } from "mobx-react";
import { useState } from "react";
import export_icon from "./img/export.svg";

import "./style.scss";

const { VITE_WHAT_ID } = import.meta.env;

const AB_2659 = inject("mainStore")(
    observer(({ mainStore, offer, className = "" }) => {
        const abTest = mainStore.getMainStore("abTest");
        const abTestMetika = mainStore.getMainStore("abTestMetika");

        const isMobileView = useHandleResize();
        const [shareListOpen, setShareListOpen] = useState(false);
        const what_id = getWhatId() ? getWhatId() : VITE_WHAT_ID;
        const isAbTestMetrika = getAbTestMetrika(abTest, offer?._id);

        const handleCopy = () => {
            navigator.clipboard.writeText(window.location.href).then(() => {
                mainStore.setMainStore("toast", { severity: "success", life: 4000, summary: "", detail: "Cсылка копирована" });
            });

            sendMetric("click_copy_share_link", {
                params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                params2: offer?._id,
                params3: getSqlServerGuidHash(offer.code, offer.vendor?._id),
                params4: offer?.code,
                params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                params7: null,
                params8: what_id,
            });
        };

        const clickHandlerShareItem = (e, item) => {
            e.stopPropagation();
            switch (item.label) {
                case "Телеграм":
                    sendMetric("click_offer_share_telegram", {
                        params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                        params2: offer?._id,
                        params3: getSqlServerGuidHash(offer.code, offer.vendor?._id),
                        params4: offer?.code,
                        params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                        params7: null,
                        params8: what_id,
                    });
                    break;
                case "ВКонтакте":
                    sendMetric("click_offer_share_vkontakte", {
                        params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                        params2: offer?._id,
                        params3: getSqlServerGuidHash(offer.code, offer.vendor?._id),
                        params4: offer?.code,
                        params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                        params7: null,
                        params8: what_id,
                    });
                    break;
                case "Одноклассники":
                    sendMetric("click_offer_share_odnoklassniki", {
                        params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                        params2: offer?._id,
                        params3: getSqlServerGuidHash(offer.code, offer.vendor?._id),
                        params4: offer?.code,
                        params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                        params7: null,
                        params8: what_id,
                    });
                    break;
                default:
                    break;
            }
            window.open(`${item.link}${window.location.href}`, "_blank");
            setShareListOpen(false);
        };

        const handleShare = (e) => {
            e.stopPropagation();
            sendMetric("click_offer_main_share", {
                params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                params2: offer?._id,
                params3: getSqlServerGuidHash(offer.code, offer.vendor?._id),
                params4: offer?.code,
                params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                params7: null,
                params8: what_id,
            });

            if (navigator.share) {
                navigator
                    .share({
                        title: "RIS PROMO",
                        // text: `${offer.title}`,
                        url: `${window.location.href}`,
                    })
                    .then(() => {})
                    .catch((error) => {
                        console.error("Something went wrong", error);
                    });
            } else {
                console.log("not supported");
            }
        };

        return (
            <div
                className={`ab-2659 share ${isMobileView ? "mobile" : ""} ${className}  `}
                onClick={
                    isMobileView
                        ? (e) => handleShare(e)
                        : () => {
                              setShareListOpen(!shareListOpen);

                              if (!shareListOpen) {
                                  sendMetric("click_offer_main_share", {
                                      params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                                      params2: offer?._id,
                                      params3: getSqlServerGuidHash(offer.code, offer.vendor?._id),
                                      params4: offer?.code,
                                      params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                                      params7: null,
                                      params8: what_id,
                                  });
                              }
                          }
                }
            >
                <img src={export_icon} />

                <div className={`share-block ${shareListOpen ? "share-block_active" : ""}  `}>
                    <div className="share-block-item" onClick={() => handleCopy()}>
                        Скопировать ссылку
                    </div>
                    {shareList.map((item, index) => (
                        <div key={index} onClick={(e) => clickHandlerShareItem(e, item)} className="share-block-item">
                            {item.label}
                        </div>
                    ))}
                </div>
            </div>
        );
    }),
);

const shareList = [
    {
        label: "Телеграм",
        link: "https://t.me/share/url?url=",
    },
    {
        label: "ВКонтакте",
        link: "http://vkontakte.ru/share.php?url=",
    },
    {
        label: "Одноклассники",
        link: "https://connect.ok.ru/offer?url=",
    },
];

export default AB_2659;
